import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n";

const AppContext = createContext(null);

export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const q = new URLSearchParams(window.location.search).get("lang");
    return q === "en" || q === "ar" ? q : localStorage.getItem("do_lang") || "ar";
  });
  const [theme, setTheme] = useState(() => localStorage.getItem("do_theme") || "dark");

  useEffect(() => {
    localStorage.setItem("do_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("do_theme", theme);
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  const t = (key) => {
    const e = translations[key];
    if (e) return e[lang] ?? e[lang === "ar" ? "en" : "ar"] ?? key;
    const tail = key.split(".").pop() || key;
    return tail.replace(/[_-]+/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").replace(/^\w/, (c) => c.toUpperCase());
  };
  const toggleLang = () => setLang((l) => (l === "ar" ? "en" : "ar"));
  const toggleTheme = () => setTheme((th) => (th === "dark" ? "light" : "dark"));

  return (
    <AppContext.Provider value={{ lang, theme, t, toggleLang, toggleTheme }}>
      {children}
    </AppContext.Provider>
  );
}
